function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GroupAnimation = /*#__PURE__*/function () {
  function GroupAnimation(animations) {
    var _this = this;

    _classCallCheck(this, GroupAnimation);

    // Bound to accomadate common `return animation.stop` pattern
    this.stop = function () {
      return _this.runAll("stop");
    };

    this.animations = animations.filter(Boolean);
  }

  _createClass(GroupAnimation, [{
    key: "finished",
    get: function get() {
      return Promise.all(this.animations.map(function (animation) {
        return animation.finished;
      }));
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */

  }, {
    key: "getAll",
    value: function getAll(propName) {
      return this.animations[0][propName];
    }
  }, {
    key: "setAll",
    value: function setAll(propName, newValue) {
      for (var i = 0; i < this.animations.length; i++) {
        this.animations[i][propName] = newValue;
      }
    }
  }, {
    key: "attachTimeline",
    value: function attachTimeline(timeline) {
      var _this2 = this;

      var subscriptions = this.animations.map(function (animation) {
        return animation.attachTimeline(timeline);
      });
      return function () {
        subscriptions.forEach(function (cancel, i) {
          cancel && cancel();

          _this2.animations[i].stop();
        });
      };
    }
  }, {
    key: "time",
    get: function get() {
      return this.getAll("time");
    },
    set: function set(time) {
      this.setAll("time", time);
    }
  }, {
    key: "speed",
    get: function get() {
      return this.getAll("speed");
    },
    set: function set(speed) {
      this.setAll("speed", speed);
    }
  }, {
    key: "state",
    get: function get() {
      return this.getAll("state");
    }
  }, {
    key: "startTime",
    get: function get() {
      return this.getAll("startTime");
    }
  }, {
    key: "duration",
    get: function get() {
      var max = 0;

      for (var i = 0; i < this.animations.length; i++) {
        max = Math.max(max, this.animations[i].duration);
      }

      return max;
    }
  }, {
    key: "runAll",
    value: function runAll(methodName) {
      this.animations.forEach(function (controls) {
        return controls[methodName]();
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.runAll("play");
    }
  }, {
    key: "pause",
    value: function pause() {
      this.runAll("pause");
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.runAll("cancel");
    }
  }, {
    key: "complete",
    value: function complete() {
      this.runAll("complete");
    }
  }]);

  return GroupAnimation;
}();

export { GroupAnimation };